<template>
    <form-item-wrapper :widget="widget" :formData="formData" ref="itemref">
        <RichEditor v-model="formData[widget.name]" :disabled="widget.options.disabled"
            :uploadFunction="widget.options.uploadFunction" :name="widget.name" :config="config" :id="id">
        </RichEditor>
    </form-item-wrapper>
</template>

<script setup>
import FormItemWrapper from "./form-item-wrapper.vue";
import RichEditor from "@/components/rich-editor/rich-editor.vue"
import { ref, toRefs, computed } from 'vue';
import useEvent from "./useEvent";
import { generateId } from "@/components/tools"

const props = defineProps({
    widget: Object,
    formData: Object,
})
const { widget, formData } = toRefs(props)
const itemref = ref(null)
const config = computed(() => {
    if (widget.value.options.customToolbar) {
        return {
            toolbars: [widget.value.options.customToolbar],
            maximumWords: widget.value.options.maximumWords || 1000,
            initialFrameHeight: widget.value.options.initialFrameHeight || 180, // 高度
            autoHeightEnabled: false, // 禁止自动增高，改用滚动条
        }
    } else {
        return {
            maximumWords: widget.value.options.maximumWords || 1000,
            initialFrameHeight: widget.value.options.initialFrameHeight || 180, // 高度
            autoHeightEnabled: false, // 禁止自动增高，改用滚动条
        }
    }
})
const id = computed(() => 'ue' + generateId())

const {
    handleOnChange,
    handleOnPressEnter,
} = useEvent(widget.value, itemref, formData.value);
</script>